define('views/pages/favorites/goods/table',['require','jquery','underscore','helpers/application','chaplin','views/base/view','views/base/collection','models/pages/favorites/goodsItem','text!templates/pages/favorites/goods/table.ejs'],function(require) {
    'use strict';

    var $ = require('jquery'),
        _ = require('underscore'),
        applicationHelper = require('helpers/application'),
        Chaplin = require('chaplin'),
        View = require('views/base/view'),
        CollectionView = require('views/base/collection'),
        GoodsItemModel = require('models/pages/favorites/goodsItem'),
        templateTable = require('text!templates/pages/favorites/goods/table.ejs');

    var FavoritesGoodsTableView = View.extend({
        region: 'favorites-goods-table',
        autoRender: true,
        className: 'favorites-table',
        // itemView: FavoritesGoodsRowView,
        animationDuration: 0,
        template: templateTable,
        listSelector: 'tbody',
        fallbackSelector: '.empty',
        listen: {
            'addedToDOM': 'onAddedToDOM',
            'resize model': 'onResize',
            'filterChanged model': 'render',
            'change:loading model': 'onChangeLoading',
            'addFavoriteGoods mediator': 'onAddFavoriteGoods',
            'removeFavoriteGoods mediator': 'onRemoveFavoriteGoods'
        },
        events: {
            'click .goods-table-favorite': 'onClickFavorite'
        },
        onChangeLoading: function(){
            this.$('tbody')[({ true: 'addClass', false: 'removeClass' })[this.model.get('loading') || false]]('preloader');
        },
        initialize: function() {
            View.prototype.initialize.apply(this, arguments);

            this.model.filter.on('filterChanged', _.bind(this.onResizeDelayed, this));
        },
        onClickFavorite: function(ev){
            var $el = $(ev.currentTarget);
            var index =$el.parent().index();
            var _this = this;
            var items = this.model.get('items');
            var item = items[index];

            if (!item) { return; }

            if (item.id) {
                $el.removeClass('active');

                Chaplin.mediator.execute('removeFavoriteGoods', item.id);
            } else {
                $el.addClass('active');

                Chaplin.mediator.execute('addFavoriteGoods', item.goodsId);
            }
        },
        onAddFavoriteGoods: function(data){
            var found = _.findWhere(this.model.get('items'), { id: data.id });
            if (found) {
                found.id = data.id;
            }
        },
        onRemoveFavoriteGoods: function(data){
            var items = this.model.get('items');
            var index = _.findIndex(items, { id: data.id });
            var found = items[index];
            if (found) {
                if (this.model.get('favFilter') === 'favs') {
                    items.splice(index,1);
                    this.render();
                } else {
                    found.id = null;
                }
            }

            if(items.length === 0 && this.model.get('favFilter') === 'favs'){
                applicationHelper.redirectTo('favorites#show', { page: this.model.get('page'), favFilter: 'all' });
            }

        },
        onResizeDelayed: function() {
            setTimeout(_.bind(this.onResize, this), 10);
        },
        onAddedToDOM: function() {
            this.onResize();
            this.onChangeLoading();
        },
        render: function() {
            View.prototype.render.apply(this, arguments);

            if (document.body.contains(this.el)) {
                this.onAddedToDOM();
            }
        },
        onResize: function() {
            if(this.$el){
                var h = $('body').height();
                var $b = this.$('tbody');

                var newHeight = h - $b.offset().top - 12;
                var itemsCount = Object.keys(this.model.get('items')).length;
                if(itemsCount === 0){
                    newHeight = h - 261 - 12;
                }
                $b.css('height', newHeight);
            }
        },
        updateFilter: function(item){
            var attr = item.attributes;
            var fIndex = _.findIndex(this.model.filterSetupData.source, {id: attr.id});
            if(fIndex !== -1){
                this.model.filterSetupData.source[fIndex] = attr;
            }
            this.model.filter.setup(this.model.filterSetupData);
        }
    });

    return FavoritesGoodsTableView;
});
